<template>
  <div class="assets-root">
    <pui-file-assets
      :forcedSelectedFiles="selectedFiles"
      @openSelectionDialog="openSelectionDialog"
    />
    <pui-file-selection-dialog
      ref="fileSelectionDialog"
      @resetSelectedFiles="onResetSelectedFiles"
    />
  </div>
</template>

<script>
import puiFileAssets from '../components/files/FileAssets';
import puiFileSelectionDialog from '../components/files/FileSelectionDialog';

export default {
  components: {
    puiFileAssets,
    puiFileSelectionDialog,
  },
  data() {
    return {
      selectedFiles: [],
    };
  },
  methods: {
    // FILES
    /**
     * Clears the selected files
     *
     * @returns {void}
     */
    onResetSelectedFiles(selectedFiles) {
      this.selectedFiles = [];
      this.$refs.fileSelectionDialog.close();
    },
    /**
     * Opens the selection dialog
     *
     * @param {object[]} selectedFiles - the selected files to display
     * @returns {void}
     */
    openSelectionDialog(selectedFiles) {
      this.$refs.fileSelectionDialog.open(selectedFiles);
    },
  },
};
</script>
